import './MobileMenu.css';
export var animationWrapper = '_1y10jfb-3-15-1';
export var backButton = '_1y10jf1-3-15-1';
export var body = '_1y10jf8-3-15-1';
export var enterBack = '_1y10jfe-3-15-1';
export var enterForward = '_1y10jfd-3-15-1';
export var exitBack = '_1y10jfg-3-15-1';
export var exitForward = '_1y10jff-3-15-1';
export var header = '_1y10jf9-3-15-1';
export var headerDivider = '_1y10jfa-3-15-1';
export var headerTitleText = '_1y10jf3-3-15-1';
export var headerTitleWrapper = '_1y10jf2-3-15-1';
export var panel = '_1y10jf0-3-15-1';
export var panelContent = '_1y10jfc-3-15-1';